import React from 'react';
import { Link } from 'react-router-dom';
import { products, tocProducts, tobProducts } from '../data/products';

/**
 * 全站页脚。视觉统一到 sx- 体系：分组标题用等宽大写标签，
 * 链接静默到 mute 色、hover 才升到纯白，层级只靠 hairline 建立。
 *
 * 备案号与主体名称是法定必须展示项，任何改版都不能动。
 */
const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: 'var(--sx-canvas)', borderTop: '1px solid var(--sx-line)' }}>
      <div className="sx-shell py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* 品牌 */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link
              to="/"
              className="text-base font-medium text-white no-underline"
              style={{ letterSpacing: '-0.02em' }}
            >
              三米云科技
            </Link>
            <p className="sx-mono mt-2.5">Product-Driven Tech</p>
            <p className="sx-small mt-4 max-w-xs">
              自研 ToC 应用与 ToB 企业产品，连接用户价值与商业增长。
            </p>

            {/* 工程感徽章：等宽 + hairline，克制地强调"全自研"这个事实 */}
            <div className="sx-chip mt-6">
              <span className="sx-dot sx-dot-live" aria-hidden="true" />
              {products.length} 款产品 · 全部自主研发
            </div>
          </div>

          {/* ToC 产品 */}
          <div>
            <h4 className="sx-mono mb-5">Consumer</h4>
            <ul className="space-y-3">
              {tocProducts.map((product) => (
                <li key={product.id}>
                  <Link to={product.route ?? '/products#toc'} className="sx-footer-link">
                    {product.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ToB 产品 */}
          <div>
            <h4 className="sx-mono mb-5">Enterprise</h4>
            <ul className="space-y-3">
              {tobProducts.map((product) => (
                <li key={product.id}>
                  <Link to={product.route ?? '/products#tob'} className="sx-footer-link">
                    {product.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 公司 / 支持 / 商务 */}
          <div>
            <h4 className="sx-mono mb-5">Company</h4>
            <ul className="space-y-3 mb-8">
              <li>
                <Link to="/about" className="sx-footer-link">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/news" className="sx-footer-link">
                  新闻动态
                </Link>
              </li>
            </ul>

            <h4 className="sx-mono mb-5">Support</h4>
            <ul className="space-y-3 mb-8">
              <li>
                <Link to="/faq" className="sx-footer-link">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/contact" className="sx-footer-link">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/products/ququ/user-agreement" className="sx-footer-link">
                  用户协议
                </Link>
              </li>
              <li>
                <Link to="/products/ququ/privacy-policy" className="sx-footer-link">
                  隐私政策
                </Link>
              </li>
            </ul>

            <h4 className="sx-mono mb-3">Business</h4>
            <a
              href="mailto:service@bestsmy.com"
              className="sx-footer-link"
              style={{ color: 'var(--sx-dim)' }}
            >
              service@bestsmy.com
            </a>
          </div>
        </div>

        <div
          className="mt-12 pt-6 flex flex-col md:flex-row justify-between gap-3"
          style={{ borderTop: '1px solid var(--sx-line)' }}
        >
          <p className="sx-mono sx-mono-plain">
            © {currentYear} 三米云（上海）科技有限公司
          </p>
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            rel="noopener noreferrer"
            className="sx-footer-link"
            style={{ fontSize: '0.6875rem' }}
          >
            沪ICP备2025126765号-1
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
